import { CookieBanner } from '@/components/cookie-banner/cookie-banner.tsx';
import { CookiesProvider } from 'react-cookie';
import { Footer } from './footer';

interface Props {
  children: React.ReactNode;
}

export function CookieContainer({ children }: Props) {
  return (
    <div
      style={{
        position: 'relative',
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <CookiesProvider>
        <CookieBanner />
        {children}
        <Footer />
      </CookiesProvider>
    </div>
  );
}
